import type React from 'react';

import { GooglePlacesProvider } from '#src/app/shared/hooks/googlePlaces';

import { PlaceFieldSunrise } from './PlaceFieldSunrise';
import type { PlaceFieldSunriseProps } from './PlaceFieldSunrise';

export const PlaceFieldSunriseWrapper: React.FC<PlaceFieldSunriseProps> = (props) => {
	return (
		<GooglePlacesProvider>
			<PlaceFieldSunrise {...props} />
		</GooglePlacesProvider>
	);
};
